// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__LlSb0","container__image":"styles_container__image__y5ZEt","skeleton-animation":"styles_skeleton-animation__y1BGx"};